import "firebase/compat/storage"
import firebase from "firebase/compat/app";
import "firebase/compat/auth"
import "firebase/compat/database"
// import "firebase/compat/analytics"

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBhAC69QWQocrSr9Y96Yg4gxWp_Nzv7eX8",
    authDomain: "chat-99274.firebaseapp.com",
    databaseURL: "https://chat-99274.firebaseio.com",
    projectId: "chat-99274",
    storageBucket: "chat-99274.firebasestorage.app",
    messagingSenderId: "749993060050",
    appId: "1:749993060050:web:0a529fadd3df8f7991af0b"
})
const auth = firebaseApp.auth()
const db = firebaseApp.database()
// const analytics = firebaseApp.analytics()
const storage = firebaseApp.storage()

// analytics.setAnalyticsCollectionEnabled(true)

export { auth, db, storage }